import React from "react";
import { useTranslation } from "react-i18next";
import { CrossIcon } from "@aureskonnect/react-ui";

import { CustomCardHeader } from "../../../../components/Common/CustomCardStyled";
import { capitalize } from "../../../../helpers/general";

type Props = {
    onClose: () => void;
};

export function FormHeader({ onClose }: Props) {
    const { t } = useTranslation();
    return (
        <CustomCardHeader className="d-flex align-items-center justify-content-between">
            <h5 className="pt-3">{capitalize(t("Fidelity setting"))}</h5>
            <CrossIcon
                className="icon-close-notification__clz"
                height={13}
                width={13}
                onClick={onClose}
            />
        </CustomCardHeader>
    );
}
